import styled from 'styled-components';
import { Form } from 'formik';
import {
  ErrorMsg,
  Icon,
  Label,
  Select,
  WarningNotice,
  Tooltip,
  Input,
  Td,
} from '@studio/legacy-components';
import { Conditions } from 'next/components/Conditions';

export const Loading = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

export const InformativeLabelText = styled.span`
  ${Icon} {
    color: var(--dark-resting);
  }
`;

export const DetailsForm = styled(Form)`
  // @todo this doesn't seem to match the global placement for form errors
  ${Label} {
    padding-bottom: 24px;

    ${ErrorMsg} {
      position: absolute;
      bottom: 0px;
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${Conditions}:last-child {
    margin-bottom: 16px;
  }
`;

export const SectionTitle = styled.span`
  font-weight: var(--bold);
  color: var(--heading-primary);
`;

export const HelpText = styled.p`
  color: var(--sharkbait-ooh-la-la);
`;

export const HelpTextEmphasis = styled.span`
  color: var(--gradient-green);
  font-weight: var(--bold);
`;

export const Targeting = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0 0 24px;
`;

export const FlagWrapper = styled.span`
  font-weight: var(--normal);
  color: ${({ $installed }) =>
    $installed ? 'var(--pleather)' : 'var(--dirty-water)'};

  ${Icon} {
    margin-left: 8px;
    color: ${({ $installed }) =>
      $installed ? 'var(--cutecumber)' : 'var(--sharkbait-ooh-la-la)'};
  }
`;

export const FlagTitleText = styled.div`
  font-weight: var(--bold);
`;

export const SegmentTargeting = styled.div`
  display: flex;
  gap: 12px;
`;

export const URLList = styled.ul`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QualifiedIcon = styled(Icon)`
  font-size: var(--medium-large);
`;

export const URLItemWrapper = styled.li`
  align-items: center;
  display: flex;
  gap: 8px;
  list-style: none;

  ${QualifiedIcon} {
    color: var(--dark-resting);
    ${({ $qualified, $installed }) =>
      $qualified &&
      `
        color: ${$installed ? 'var(--cutecumber)' : 'var(--rubber-ducky)'};
    `};
  }
`;

export const URLLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95%;
`;

export const SelectField = styled.div`
  width: 90%;

  ${Select} {
    max-width: inherit;
  }
`;

export const URLSelectWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const URLNotice = styled(WarningNotice)`
  margin-top: 16px;
`;

export const URLTooltip = styled(Tooltip)`
  // TODO: this should be in Tooltip <Wrapper> default styles. It's added here in order to avoid
  // visual regression in other places that we should work separately.
  display: inline-flex;
`;

export const FieldInput = styled(Input)`
  margin-bottom: ${props => (props.error ? '' : '24px')};
`;

export const TableContainer = styled.div`
  ${Td} {
    border: none;
    vertical-align: top;

    &:nth-of-type(1) {
      font-weight: var(--bold);
      width: 100px;
    }

    &:nth-of-type(2) {
      max-width: 30em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;

      &::first-letter {
        text-transform: uppercase;
      }
    }
  }
`;
